import FilterAttributeHotelMethodsByType from '@fr/vue/components/filters/common/filterMethods/filterAttributeMethodsHotelBoolean/FilterAttributeHotelMethodsByType';

export default new FilterAttributeHotelMethodsByType('NearCenterFilter');